import React, { useContext } from 'react';
import { map } from 'lodash';
import classnames from "classnames";
import { BaseContext } from '../../../contexts';
import remoteFiles from '../../../../../common/remote_files';
import PlansListStatistics from '../../../components/plansListStatistics';

const Plans = ({ onBack, onSelect }) => {
  const { plans, addElementToScrollablePlan } = useContext(BaseContext);
  const handleOnSelect = (plan) => () => {
    onSelect(plan);
  };
  return (
    <PlansListStatistics>
      <div className="subscriptions">
        <header className="sticky-header">
          <button className="back-button" onClick={ onBack }>
            <span className="dash" />
            Subscriptions
          </button>
        </header>
        <img
          className="subscription-title-image"
          src={ remoteFiles.verizon.dynamicOffer.bauImage.plansImage }
          alt="plans image"
        />
        <div className="subscriptions-main">
          {
            map(plans, (plan) => (
              <div
                key={ plan.id }
                className={ classnames("subscription-card", { 'best-value': plan.bestValue }) }
              >
                { plan.bestValue && <div className="badge">Best value</div> }
                <div className="card-content">
                  <h4 ref={ addElementToScrollablePlan(plan) }>{ plan.title }</h4>
                  <p className="price">{ plan.price }</p>
                  <p className="description">{ plan.note }</p>
                  { plan.description }
                  <button className="button select-button" onClick={ handleOnSelect(plan) }>
                    Select
                  </button>
                </div>
              </div>
            ))
          }
          <div className="asterisk-note">
            * Plus taxes and Verizon surcharges. Your Cloud plan will auto-renew at the monthly
            { ' ' }
            charge until you cancel. Cancel anytime in Verizon Cloud app.
          </div>
          <div className="plans-bottom">
            <button className="button alt-button">Log in to other account</button>
          </div>
        </div>
      </div>
    </PlansListStatistics>
  );
};

export default Plans;
